import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React from 'react';
import { Col, Row } from 'react-grid-system';
import { connect } from 'react-redux';
import { saveFormulariosData } from '../../../common/Actions';
import Btn from '../../../common/components/Btn/Btn';
import Select from '../../../common/components/Fields/Select';
import Provider from '../../../common/components/Provider/Provider';
import Helpers from '../../../common/Helpers';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import ClientsServcices from "../../../services/Clients";
import Margenes from '../../../services/Margenes';
import Store from '../../../common/Store';
import { resource } from '../../../common/lang/lang';

class Lista extends React.Component {

    Cities = resource('Cities');

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 0,
            total: 0
        }
    }

    componentDidMount() {
        this.getAll();
        this.getData(0);
    }

    async getAll() {
        let [clientes] = await Promise.all([
            ClientsServcices.get()
        ]);
        this.setState(() => ({ clients: clientes.data }));
    }

    async getData(page) {
        let form = Store.getState().formularios
        let [margenes] = await Promise.all([
            Margenes.get(form, page)
        ])

        this.setState(() => ({ data: margenes.data, total: margenes.total, page: page }))
    }

    search = () => {
        this.setState(() => ({ page: 0 }));
        this.getData();
    }

    edit = id => () => this.props.history.push(`/margenes/edit/${id}`);
    view = id => () => this.props.history.push(`/margenes/view/${id}`);

    changePage = async (event, page) => {
        this.getData(page);
    };


    render() {
        const { state, props: { campo } } = this;
        return (
            <div className="formdata">
                <Row>
                    <Col>
                        <h2>Margenes</h2>
                    </Col>
                </Row>
                <div className="wrap table">
                    <Row>
                        <Provider store={'formularios'} save={saveFormulariosData}>
                            <Col md={10}>

                                <Select name={'campo'} opts={[
                                    {
                                        name: 'Cliente',
                                        code: 'cliente'
                                    },
                                ]} />
                                {campo === 'cliente' &&
                                    <Select name={'search'} label={'Buscar...'} optionLabel={Helpers.clientsLabels} opts={state.clients} hash={'id'} />
                                }

                            </Col>
                            <Col md={2}>
                                <Btn text={"Buscar"} type={'primary'} class={'btn-block'} click={this.search} />
                            </Col>
                        </Provider>
                    </Row>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Cliente</TableCell>
                                    <TableCell>Origen</TableCell>
                                    <TableCell>Destino</TableCell>
                                    <TableCell>Margen</TableCell>
                                    <TableCell>Val. día cond.</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.isArray(state.data) && state.data.map((item, key) =>
                                    <React.Fragment key={key}>
                                        <TableRow>
                                            <TableCell>{item.cliente.names}</TableCell>
                                            <TableCell>{Helpers.getStatic(item.origen, this.Cities).name}</TableCell>
                                            <TableCell>{Helpers.getStatic(item.destino, this.Cities).name}</TableCell>
                                            <TableCell>{item.margen} %</TableCell>
                                            <TableCell>{Helpers.formatToMask(item.val_dia_conductor)}</TableCell>
                                            <TableCell className="last-td">
                                                {item.state !== 5 && <IconButton size="small" onClick={this.edit(item.id)}><EditIcon /></IconButton>}
                                                {item.state === 5 && <IconButton size="small" onClick={this.view(item.id)}><VisibilityIcon /></IconButton>}
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={state.total}
                            rowsPerPage={10}
                            page={state.page}
                            onChangePage={this.changePage}
                        />
                    </TableContainer>
                </div>
            </div>
        )
    }

}

export default connect(
    (store) => ({
        campo: store.formularios.campo
    }),
    (dispatch) => ({}),
)(Lista);